import React from 'react';
import PropTypes from 'prop-types';

import SelectControl from 'app/components/forms/selectControl';
import InputField from 'app/views/settings/components/forms/inputField';

const getChoices = props => {
  let choices = props.choices || [];

  if (typeof props.choices === 'function') {
    choices = props.choices(props);
  }

  return choices;
};

export default class SelectField extends React.Component {
  static propTypes = {
    // TODO(ts)
    // ...InputField.propTypes,
    choices: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
    options: PropTypes.arrayOf(PropTypes.object),
    allowClear: PropTypes.bool,
    allowEmpty: PropTypes.bool,
    multiple: PropTypes.bool,
    escapeMarkup: PropTypes.bool,
    small: PropTypes.bool,
    inFieldLabel: PropTypes.string,
    stacked: PropTypes.bool,
  };

  static defaultProps = {
    // TODO(ts)
    // ...InputField.propTypes,
    allowClear: false,
    allowEmpty: false,
    placeholder: '--',
    escapeMarkup: true,
    multiple: false,
    small: false,
    formatMessageValue: (value, props) =>
      (getChoices(props).find(choice => choice[0] === value) || [null, value])[1],
  };

  handleChange = (onBlur, onChange, optionObj) => {
    let value;

    // If optionObj is empty, then it probably means that the field was "cleared"
    if (!optionObj) {
      value = optionObj;
    } else if (this.props.multiple) {
      // List of optionObjs
      value = optionObj.map(({value: val}) => val);
    } else {
      value = optionObj.value;
    }

    onChange(value, {});
    onBlur(value, {});
  };

  render() {
    const {multiple, allowClear, ...otherProps} = this.props;
    return (
      <InputField
        {...otherProps}
        alignRight={this.props.small}
        field={({onChange, onBlur, required: _required, ...props}) => (
          <SelectControl
            {...props}
            clearable={allowClear}
            multiple={multiple}
            onChange={this.handleChange.bind(this, onBlur, onChange)}
          />
        )}
      />
    );
  }
}
